module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "containerDiv"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pagesInfo.length > 1),
      expression: "pagesInfo.length > 1"
    }],
    staticClass: "pagination"
  }, _vm._l((_vm.pagesInfo), function(n, index) {
    return _c('li', [_c('span', {
      on: {
        "click": function($event) {
          return _vm.GoToUrl(n)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": n,
        "tag": "a"
      }
    }, [_c('span', [_vm._v(_vm._s(index + 1))])])], 1)])
  }), 0)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5b1922e4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b1922e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/misc/Pagination.vue
// module id = 116
// module chunks = 0